import { render } from "./LocalSpinner.vue?vue&type=template&id=c4c37a02"
import script from "./LocalSpinner.vue?vue&type=script&lang=js"
export * from "./LocalSpinner.vue?vue&type=script&lang=js"

import "./LocalSpinner.vue?vue&type=style&index=0&id=c4c37a02&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__